 import Vue from 'vue'

const api = Vue.prototype.$api

export default {
  getSpecialities () {
    return api.get('/specialties')
  },
  getSpecialitiesByPromotionCode (promotionCode) {
    return api.get('/Specialties/GetSpecialitiesByPromotionCode', { params: {
      promotionCode
    }
  })
  },
  getProfSpecialitiesByCity (cityId = null, withInsurers = false) {
    return api.get('/specialties/getProfSpecialtiesByCity', { params: { cityId, withInsurers } })
  },
  getCenterSpecialitiesByCity (cityId) {
    return api.get('/specialties/getCenterSpecialtiesByCity', { params: { cityId: cityId } })
  },
  isMedical (specialtyId) {
    return api.get('/specialties/isMedical', { params: { specialtyId: specialtyId } })
  },
  isMedicalProfessional (profId) {
    return api.get('/specialties/IsMedicalProfessional', { params: { profId: profId } })
  }
}


// WEBPACK FOOTER //
// ./src/repositories/SpecialitiesRepository.js